// source: accounts/protos/invoice.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var accounts_protos_invoice_dto_pb = require('../../accounts/protos/invoice_dto_pb.js');
goog.object.extend(proto, accounts_protos_invoice_dto_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.accounts.protos.InvoiceListResponse', null, global);
goog.exportSymbol('proto.accounts.protos.InvoicePreviewResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.InvoiceListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accounts.protos.InvoiceListResponse.repeatedFields_, null);
};
goog.inherits(proto.accounts.protos.InvoiceListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.InvoiceListResponse.displayName = 'proto.accounts.protos.InvoiceListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.InvoicePreviewResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accounts.protos.InvoicePreviewResponse.repeatedFields_, null);
};
goog.inherits(proto.accounts.protos.InvoicePreviewResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.InvoicePreviewResponse.displayName = 'proto.accounts.protos.InvoicePreviewResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accounts.protos.InvoiceListResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.InvoiceListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.InvoiceListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.InvoiceListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.InvoiceListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusCode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    invoicesList: jspb.Message.toObjectList(msg.getInvoicesList(),
    accounts_protos_invoice_dto_pb.InvoiceDTO.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.InvoiceListResponse}
 */
proto.accounts.protos.InvoiceListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.InvoiceListResponse;
  return proto.accounts.protos.InvoiceListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.InvoiceListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.InvoiceListResponse}
 */
proto.accounts.protos.InvoiceListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatusCode(value);
      break;
    case 2:
      var value = new accounts_protos_invoice_dto_pb.InvoiceDTO;
      reader.readMessage(value,accounts_protos_invoice_dto_pb.InvoiceDTO.deserializeBinaryFromReader);
      msg.addInvoices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.InvoiceListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.InvoiceListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.InvoiceListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.InvoiceListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getInvoicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      accounts_protos_invoice_dto_pb.InvoiceDTO.serializeBinaryToWriter
    );
  }
};


/**
 * required uint32 status_code = 1;
 * @return {number}
 */
proto.accounts.protos.InvoiceListResponse.prototype.getStatusCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accounts.protos.InvoiceListResponse} returns this
 */
proto.accounts.protos.InvoiceListResponse.prototype.setStatusCode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.InvoiceListResponse} returns this
 */
proto.accounts.protos.InvoiceListResponse.prototype.clearStatusCode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoiceListResponse.prototype.hasStatusCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated InvoiceDTO invoices = 2;
 * @return {!Array<!proto.accounts.protos.InvoiceDTO>}
 */
proto.accounts.protos.InvoiceListResponse.prototype.getInvoicesList = function() {
  return /** @type{!Array<!proto.accounts.protos.InvoiceDTO>} */ (
    jspb.Message.getRepeatedWrapperField(this, accounts_protos_invoice_dto_pb.InvoiceDTO, 2));
};


/**
 * @param {!Array<!proto.accounts.protos.InvoiceDTO>} value
 * @return {!proto.accounts.protos.InvoiceListResponse} returns this
*/
proto.accounts.protos.InvoiceListResponse.prototype.setInvoicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.accounts.protos.InvoiceDTO=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.InvoiceDTO}
 */
proto.accounts.protos.InvoiceListResponse.prototype.addInvoices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.accounts.protos.InvoiceDTO, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.InvoiceListResponse} returns this
 */
proto.accounts.protos.InvoiceListResponse.prototype.clearInvoicesList = function() {
  return this.setInvoicesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accounts.protos.InvoicePreviewResponse.repeatedFields_ = [4,5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.InvoicePreviewResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.InvoicePreviewResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.InvoicePreviewResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusCode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    isTrialing: (f = jspb.Message.getBooleanField(msg, 2)) == null ? undefined : f,
    trialUntil: (f = msg.getTrialUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    chargesList: jspb.Message.toObjectList(msg.getChargesList(),
    accounts_protos_invoice_dto_pb.InvoiceDTO.toObject, includeInstance),
    refundsList: jspb.Message.toObjectList(msg.getRefundsList(),
    accounts_protos_invoice_dto_pb.InvoiceDTO.toObject, includeInstance),
    notesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.InvoicePreviewResponse}
 */
proto.accounts.protos.InvoicePreviewResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.InvoicePreviewResponse;
  return proto.accounts.protos.InvoicePreviewResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.InvoicePreviewResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.InvoicePreviewResponse}
 */
proto.accounts.protos.InvoicePreviewResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatusCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsTrialing(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTrialUntil(value);
      break;
    case 4:
      var value = new accounts_protos_invoice_dto_pb.InvoiceDTO;
      reader.readMessage(value,accounts_protos_invoice_dto_pb.InvoiceDTO.deserializeBinaryFromReader);
      msg.addCharges(value);
      break;
    case 5:
      var value = new accounts_protos_invoice_dto_pb.InvoiceDTO;
      reader.readMessage(value,accounts_protos_invoice_dto_pb.InvoiceDTO.deserializeBinaryFromReader);
      msg.addRefunds(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.InvoicePreviewResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.InvoicePreviewResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.InvoicePreviewResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getTrialUntil();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getChargesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      accounts_protos_invoice_dto_pb.InvoiceDTO.serializeBinaryToWriter
    );
  }
  f = message.getRefundsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      accounts_protos_invoice_dto_pb.InvoiceDTO.serializeBinaryToWriter
    );
  }
  f = message.getNotesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
};


/**
 * required uint32 status_code = 1;
 * @return {number}
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.getStatusCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accounts.protos.InvoicePreviewResponse} returns this
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.setStatusCode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.InvoicePreviewResponse} returns this
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.clearStatusCode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.hasStatusCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool is_trialing = 2;
 * @return {boolean}
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.getIsTrialing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.InvoicePreviewResponse} returns this
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.setIsTrialing = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.InvoicePreviewResponse} returns this
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.clearIsTrialing = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.hasIsTrialing = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp trial_until = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.getTrialUntil = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accounts.protos.InvoicePreviewResponse} returns this
*/
proto.accounts.protos.InvoicePreviewResponse.prototype.setTrialUntil = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.InvoicePreviewResponse} returns this
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.clearTrialUntil = function() {
  return this.setTrialUntil(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.hasTrialUntil = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated InvoiceDTO charges = 4;
 * @return {!Array<!proto.accounts.protos.InvoiceDTO>}
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.getChargesList = function() {
  return /** @type{!Array<!proto.accounts.protos.InvoiceDTO>} */ (
    jspb.Message.getRepeatedWrapperField(this, accounts_protos_invoice_dto_pb.InvoiceDTO, 4));
};


/**
 * @param {!Array<!proto.accounts.protos.InvoiceDTO>} value
 * @return {!proto.accounts.protos.InvoicePreviewResponse} returns this
*/
proto.accounts.protos.InvoicePreviewResponse.prototype.setChargesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.accounts.protos.InvoiceDTO=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.InvoiceDTO}
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.addCharges = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.accounts.protos.InvoiceDTO, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.InvoicePreviewResponse} returns this
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.clearChargesList = function() {
  return this.setChargesList([]);
};


/**
 * repeated InvoiceDTO refunds = 5;
 * @return {!Array<!proto.accounts.protos.InvoiceDTO>}
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.getRefundsList = function() {
  return /** @type{!Array<!proto.accounts.protos.InvoiceDTO>} */ (
    jspb.Message.getRepeatedWrapperField(this, accounts_protos_invoice_dto_pb.InvoiceDTO, 5));
};


/**
 * @param {!Array<!proto.accounts.protos.InvoiceDTO>} value
 * @return {!proto.accounts.protos.InvoicePreviewResponse} returns this
*/
proto.accounts.protos.InvoicePreviewResponse.prototype.setRefundsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.accounts.protos.InvoiceDTO=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.InvoiceDTO}
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.addRefunds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.accounts.protos.InvoiceDTO, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.InvoicePreviewResponse} returns this
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.clearRefundsList = function() {
  return this.setRefundsList([]);
};


/**
 * repeated string notes = 6;
 * @return {!Array<string>}
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.getNotesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accounts.protos.InvoicePreviewResponse} returns this
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.setNotesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.InvoicePreviewResponse} returns this
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.addNotes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.InvoicePreviewResponse} returns this
 */
proto.accounts.protos.InvoicePreviewResponse.prototype.clearNotesList = function() {
  return this.setNotesList([]);
};


goog.object.extend(exports, proto.accounts.protos);
